import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../components/commonDesign/SydModal'
import DeleteScheduleForm from './form'

const DeleteScheduleDialog = React.forwardRef(function DeleteScheduleDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (schedule) => setDialogState({
      open: true,
      processing: false,
      schedule
    })
  }), [setDialogState])

  return (
    <SydModal
      title={dialogState.schedule?.isDigest ? 'Delete Digest' : 'Delete Scheduled Prompt'}
      open={dialogState.open}
      onClose={close}
      size='sm'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DeleteScheduleForm
            schedule={dialogState.schedule}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

DeleteScheduleDialog.propTypes = {
  onComplete: PropTypes.func
}

DeleteScheduleDialog.defaultProps = {
  onComplete: () => {}
}

export default DeleteScheduleDialog
